/*
 **  This file has been migrated to the new translated structure.
 **  1) All strings must be added with the correct casing.
 **  2) New strings must be added to en_US_migrated.json.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'antd/dist/antd.css';
import './notesStyle.css';

ReactDOM.render(<App />, document.getElementById('root'));
